import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-choose-frequency',
  templateUrl: './choose-frequency.component.html',
  styleUrls: ['./choose-frequency.component.scss'],
})
export class ChooseFrequencyComponent implements OnInit {
  @Input() inputForm: FormGroup;

  initial: string;

  constructor() {
  }

  ngOnInit() {
    this.inputForm.addControl('frequency', new FormControl(this.initial || '1'));
  }
}
